'use client';

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { createThemeFromTokens } from '@fast-computing/fast-graphics/mui-theme';
import { useMemo } from 'react';

export function Providers({ children }: { children: React.ReactNode }) {
  const theme = useMemo(() => createThemeFromTokens('atlas'), []);
  
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
